import { render } from "./App.vue?vue&type=template&id=83f01a72"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=83f01a72&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__